import { render, staticRenderFns } from "./CardInformasiGudang.vue?vue&type=template&id=e3452312&"
import script from "./CardInformasiGudang.vue?vue&type=script&lang=js&"
export * from "./CardInformasiGudang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports